import { User } from 'types/auth'

export type TLoginChallenge = {
	status: 'PASSWORD_REQUIRED' | 'OTP_SENT'
	resendCooldownSeconds?: number
}

export type TAuthSuccess = { accessToken: string; user: User }

export const DEFAULT_OTP_RESEND_COOLDOWN_SECONDS = 30

export const isLoginChallenge = (
	data: TLoginChallenge | TAuthSuccess,
): data is TLoginChallenge => 'status' in data && !('accessToken' in data)
